import { UserProfiles } from "@WahooFitness/cloud-client-ts";
import { WahooWorkoutTypeFamily } from "@WahooFitness/cloud-client-types";
import { useCloudContext, useConfigContext, useOfflineSWR } from "@WahooFitness/wahoo-offline-mfe";
import { useCallback } from "react";

const useUserProfiles = () => {
  const { wahooToken } = useConfigContext();
  const { getCloudClient } = useCloudContext();
  const {
    data: userProfilesData,
    isLoading: userProfilesIsLoading,
    error: userProfilesError,
    mutate: mutateUserProfiles,
  } = useOfflineSWR(
    () => ["userProfiles", wahooToken],
    ([_key, token]) => {
      const cloudClient = getCloudClient(UserProfiles);
      return cloudClient.get(token);
    }
  );

  const updateUserProfiles = useCallback(
    async ({
      workoutTypeFamilyIds,
      workoutTypeFamilyPreferences,
    }: {
      workoutTypeFamilyIds?: WahooWorkoutTypeFamily[];
      workoutTypeFamilyPreferences?: WahooWorkoutTypeFamily[];
    }) => {
      if (userProfilesData?.id) {
        mutateUserProfiles(
          {
            ...userProfilesData,
            workout_type_family_ids:
              workoutTypeFamilyIds ?? userProfilesData?.workout_type_family_ids,
            workout_type_family_preferences:
              workoutTypeFamilyPreferences ?? userProfilesData?.workout_type_family_preferences,
          },
          { revalidate: false }
        );
        const cloudClient = getCloudClient(UserProfiles);
        await cloudClient.upsert(
          wahooToken,
          userProfilesData.id,
          workoutTypeFamilyIds ?? userProfilesData.workout_type_family_ids,
          workoutTypeFamilyPreferences ?? userProfilesData.workout_type_family_preferences
        );
      }
    },
    [getCloudClient, mutateUserProfiles, userProfilesData, wahooToken]
  );

  return {
    userProfilesData,
    userProfilesIsLoading,
    userProfilesError,
    updateUserProfiles,
  };
};

export default useUserProfiles;
